import $ from 'jquery'

let Slider = {
  Initalised : false,
  
}

Slider.init = function()
{
  if(!this.Initalised)
  {
    this.Initalised = true;
  }else{
    return false;
  }

  $('.homepage-slider').slick({
    infinite: true,
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    fade: true,
    fadeSpeed: 5000
  });

}


export default Slider;


// WEBPACK FOOTER //
// ./resources/assets/js/components/slider.js